import * as React from "react";

/**
 * Linkify Text - Wandelt URLs in Text automatisch in klickbare Links um.
 * URLs werden nicht als Klartext angezeigt, sondern als "PDF" oder "Link"
 * (analog zur Darstellung in WasserwerkRoute).
 */
interface LinkifyTextProps {
  children: string;
}

export const LinkifyText: React.FC<LinkifyTextProps> = ({ children }) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = children.split(urlRegex);

  return (
    <>
      {parts.map((part, index) => {
        if (part.match(urlRegex)) {
          // URL-Ende bereinigen (abschließende Satzzeichen entfernen)
          const cleanUrl = part.replace(/[.,;)]+$/, "");
          const isPdf = cleanUrl.toLowerCase().endsWith(".pdf");
          const label = isPdf ? "PDF" : "Link";

          return (
            <a
              key={index}
              href={cleanUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "var(--primaryColor)",
                textDecoration: "underline",
              }}
            >
              {label}
            </a>
          );
        }
        // Überflüssiges "Verfügbar unter: " am Ende entfernen,
        // da der Link direkt danach als Label steht
        const cleaned = part
          .replace(/\s*\[Online\]\.\s*Verfügbar unter:\s*$/, "")
          .replace(/\s*Verfügbar unter:\s*$/, "");
        return <React.Fragment key={index}>{cleaned}</React.Fragment>;
      })}
    </>
  );
};
